import { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "components/DynamicForm/validate";
import DynamicForm from "components/DynamicForm";
import FormButton from "components/FormButton";
import RecursiveDataPreview from "components/RecursiveDataPreview";
import { Label } from "lib";
import { dynamicFormScroll, dynamicFormScrollBottom } from "utils";
import {
  clearRecursiveFormDataKey,
  setEditIndex,
  setEditSaveData,
  setEditShowData,
  setIsEditRecursiveForm,
  setRecursiveFormData,
  setSaveData,
  setShowAddMore,
  setShowData,
  setShowDataPreview,
  setShowRecursiveForm,
  setMaxLength,
  setMinLength,
  setIsMinor,
  setArrayName,
  clearRecursiveFormData,
  clearSaveData,
  clearShowData,
  setAssociatedWf,
  setIsAssociatedWfDisabled,
  setAssociateRequired,
  setCurrentFormType,
  cleardeleteRecursiveDocument,
  setFormFields,
} from "redux/recursiveReducer";
import {
  setSelectedData as setSelectedFormData,
  clearValidateTriggered,
} from "redux/formDisplay";
import "./index.scss";
import { setdeleteDocument } from "redux/uploadDocumentReducer";
import { Row } from "react-bootstrap";
import { setSubworkFlowInfo } from "redux/dashBoardDetailReducer";
import PropTypes from "prop-types";
import { setMaxAmountExceeded } from "redux/paymentReducer";
import PaymentRecursiveDataPreview from "components/PaymentRecursiveDataPreview";

const PaymentRecursive = (props) => {
  PaymentRecursive.propTypes = {
    recursiveTrigger: PropTypes.bool,
    recursiveName: PropTypes.string,
    dataPreview: PropTypes.bool,
    setSelectedData: PropTypes.func,
    selectedData: PropTypes.object,
    inputFields: PropTypes.array,
    recursiveActions: PropTypes.array,
    handleAdd: PropTypes.func,
    handleCancel: PropTypes.func,
    recursiveTitle: PropTypes.string,
    handleBack: PropTypes.func,
    formErr: PropTypes.object,
    setFormErr: PropTypes.func,
    clearFieldError: PropTypes.func,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    recursiveRead: PropTypes.bool,
    handleNext: PropTypes.func,
  };
  
  const {
    recursiveTrigger,
    recursiveName,
    dataPreview,
    setSelectedData,
    selectedData,
    inputFields,
    recursiveActions,
    handleAdd,
    handleCancel,
    recursiveTitle,
    handleBack,
    formErr,
    setFormErr,
    clearFieldError,
    minLength,
    maxLength,
    recursiveRead,
    handleNext,
  } = props;

  const dispatch = useDispatch();

  const recursive = useSelector((state) => state.recursive);
  const formData = useSelector((state) => state.formData);
  const saveData = useSelector((state) => state.recursive.saveData);
  const showData = useSelector((state) => state.recursive.showData);
  const formFields = useSelector((state) => state.recursive.formFields);
  const staticData = useSelector((state) => state?.staticData);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const isEditRecursiveForm = useSelector(
    (state) => state.recursive?.isEditRecursiveForm
  );
  const deleteRecursiveDocument = useSelector(
    (state) => state.recursive?.deleteRecursiveDocument
  );
  const showRecursiveForm = useSelector(
    (state) => state.recursive.showRecursiveForm
  );
  const associatedWf = useSelector((state) => state.recursive.associatedWf);
  const isMinor = useSelector((state) => state.recursive.isMinor);
  const associatedWfAge = useSelector(
    (state) => state.recursive.associatedWfAge
  );
  const isEditMinor = useSelector((state) => state.recursive.isEditMinor);
  const isAssociatedDisabled = useSelector(
    (state) => state.recursive.isAssociatedDisabled
  );
  const editIndex = useSelector((state) => state.recursive.editIndex);
  //rework
  const associateRequired = useSelector(
    (state) => state?.recursive?.associateRequired
  );
  const currentFormType = useSelector(
    (state) => state?.recursive?.currentFormType
  );
  const isSignerRecursion = useSelector(
    (state) => state.recursive?.isSignerRecursion
  );
  const showDataPreview = useSelector(
    (state) => state?.recursive?.showDataPreview
  );
  const selectedFormData = useSelector((state) => state.formData?.selectedData);
  let complete_selectedData = useSelector(
    (state) => state.formData?.selectedData
  );

  const paymentDetails = useSelector(
    (state) => state?.paymentReducer?.payment_details
  );

  const [isMobile, setIsMobile] = useState(false);

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const handleAddMore = () => {
    //Removing the previously filled data to get a clean form (moved code to handleAdd)
    let recursiveNameFields = [];
    formFields.map((item) => {
      return recursiveNameFields.push({ name: item.name, label: item.label });
    });

    if (recursiveFormData?.hasOwnProperty("verification_response")) {
      dispatch(clearRecursiveFormDataKey({ key: "verification_response" }));
    }
    recursiveNameFields.map((item) => {
      dispatch(clearRecursiveFormDataKey({ key: item.name }));
    });
    dispatch(clearValidateTriggered());
    dispatch(setShowRecursiveForm(true));
    dispatch(setShowAddMore(false));
    dynamicFormScrollBottom();
    dispatch(setMaxAmountExceeded(false));
  };

  const handleEditChange = (index) => {
    Object.entries(saveData[index]).map((item) => {
      dispatch(setRecursiveFormData({ key: item[0], value: item[1] }));
    });
    dispatch(setEditIndex(index));
    dispatch(setShowAddMore(false));
    dispatch(setIsEditRecursiveForm(true));
    dispatch(setShowRecursiveForm(true));
    dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button
    setFormErr({});
    dynamicFormScrollBottom();
  };

  const handleEdit = async() => {
    if (
      complete_selectedData &&
      Object.entries(complete_selectedData)?.length == 0 &&
      Object.entries(paymentDetails)?.length > 0
    ) {
      complete_selectedData = paymentDetails?.user_data;
    }
    let validateFields = [];
    inputFields?.length &&
      inputFields?.map((_item) => {
        if (_item.hasOwnProperty("show") && IndirectEval(_item.show)) {
          validateFields = [...validateFields, _item];
        }
      });
    let errors;
    errors = await validate(
      validateFields,
      recursiveFormData,
      dispatch,
      staticData,
      null,
      recursive,
      complete_selectedData
    );
    let errKeys = Object.keys(errors);
    if (errKeys?.length !== 0) {
      setFormErr(errors);
      dynamicFormScroll();
      return;
    }
    let editRecursiveData = {};
    //   mobile,
    //   countryCode,
    //   completeMobileNumber;
    // countryCode = recursiveFormData.country_code;
    formFields.map((item) => {
      if (recursiveFormData[item.name] && IndirectEval(item?.show)) {
        editRecursiveData[item.name] = recursiveFormData[item.name];
      }
      if (recursiveFormData?.hasOwnProperty("verification_response")) {
        editRecursiveData["verification_response"] =
          recursiveFormData["verification_response"];
        dispatch(clearRecursiveFormDataKey({ key: "verification_response" }));
      }
    });

    if (deleteRecursiveDocument) {
      deleteRecursiveDocument?.map((ele) => {
        dispatch(setdeleteDocument({ key: "", value: ele }));
      });
      dispatch(cleardeleteRecursiveDocument());
    }

    const payload ={
      data: editRecursiveData,
      editIndex: editIndex,
    }

    dispatch(setEditShowData(payload));
    dispatch(setEditSaveData(payload));
    dispatch(setIsEditRecursiveForm(false));
    dispatch(setShowRecursiveForm(false));
    dispatch(setShowAddMore(true));
    dispatch(setIsAssociatedWfDisabled(false));
    dispatch(setEditIndex(-1));
    if (!isEditMinor) {
      dispatch(setAssociatedWf(false));
      dispatch(setIsMinor(false));
    }
    dynamicFormScroll();
  };

  useEffect(() => {
    checkWindowWidth();
  }, []);

  useEffect(() => {
    dispatch(setMinLength(minLength));
    dispatch(setMaxLength(maxLength));
    let formattedFormFields = inputFields?.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    dispatch(setCurrentFormType("applicant"));
    dispatch(setAssociateRequired(false));
  }, []);

  useEffect(() => {
    dispatch(setIsEditRecursiveForm(false));
    // // console.log(recursiveName);
    dispatch(clearRecursiveFormData());
    dispatch(clearShowData());
    dispatch(clearSaveData());
    let formattedFormFields = inputFields.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    dispatch(setArrayName(recursiveName));
    if (formData.selectedData[recursiveName]) {
      if (formData.selectedData[recursiveName] === true) {
        dispatch(setShowRecursiveForm(true));
        return;
      }
      dispatch(setShowDataPreview(true));
      dispatch(setShowRecursiveForm(false));
      formData.selectedData[recursiveName].map((item) => {
        dispatch(setShowData(item));
      });
      // dispatch(setShowData(...formData.selectedData[recursiveName]));
      dispatch(setSaveData(formData.selectedData[recursiveName]));
      // // console.log(inputFields[0].type === "toggle");
      if (inputFields[0].type === "toggle") {
        dispatch(
          setRecursiveFormData({ key: inputFields[0].name, value: true })
        );
      }
    } else if (
      paymentDetails &&
      paymentDetails["user_data"] &&
      paymentDetails?.user_data[recursiveName]
    ) {
      if (paymentDetails?.user_data[recursiveName] === true) {
        dispatch(setShowRecursiveForm(true));
        return;
      }
      dispatch(setShowDataPreview(true));
      dispatch(setShowRecursiveForm(false));
      paymentDetails?.user_data[recursiveName]?.map((item) => {
        dispatch(setShowData(item));
      });
      dispatch(setSaveData(paymentDetails?.user_data[recursiveName]));
      if (inputFields[0].type === "toggle") {
        dispatch(
          setRecursiveFormData({ key: inputFields[0].name, value: true })
        );
      }
    } else {
      dispatch(setShowDataPreview(false));
      dispatch(setShowRecursiveForm(true));
    }
  }, [recursiveName]);

  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  window.addEventListener("resize", () => checkWindowWidth());

  const renderDynamicForms = (fields, isRecursive) => {
    return fields?.map((item, index) => {
      const isToggleType = item.type === "toggle";
      const hasSubworkFlowInfo = Object.entries(paymentDetails)?.length > 0;

      let setSelectedDataFunc, selectedDataValue;

      if (isToggleType) {
        setSelectedDataFunc = hasSubworkFlowInfo
          ? setSubworkFlowInfo
          : setSelectedFormData;
        selectedDataValue = hasSubworkFlowInfo
          ? paymentDetails?.user_data
          : selectedFormData;
      } else {
        setSelectedDataFunc = setSelectedData;
        selectedDataValue = recursiveFormData;
      }

      return (
        <Fragment key={`paymentRecursive-${item?.name}-${index + 1}`}>
            <DynamicForm
              key={`paymentRecursive-${item?.name}-${index + 1}`}
              formErr={formErr}
              setFormErr={setFormErr}
              clearFieldError={clearFieldError}
              setSelectedData={setSelectedDataFunc}
              selectedData={selectedDataValue}
              formButtons={recursiveActions}
              recursiveFormButtons={recursiveActions}
              formFields={item}
              isRecursive={isRecursive}
            />
          </Fragment>
      );
    });
  };

  const renderRecursiveDataPreview = () => {
    return (
      <>
        <div className="px-2">
          <Label label={recursiveTitle} />
        </div>
        <PaymentRecursiveDataPreview
          recursiveRead={recursiveRead}
          recursiveTrigger={recursiveTrigger}
          data={showData}
          handleEditChange={handleEditChange}
        />

        {showRecursiveForm &&
          inputFields &&
          inputFields?.map((item, index) => {
            if (item.type === "toggle") return null;
            return (
              <Fragment key={`${recursiveTitle}_${item?.id}_${index + 1}`}>
                <DynamicForm
                  key={`${recursiveTitle}_${item?.id}_${index + 1}`}
                  formFields={item}
                  selectedData={recursiveFormData}
                  setSelectedData={setSelectedData}
                  formErr={formErr}
                  clearFieldError={clearFieldError}
                  isRecursive={true}
                />
              </Fragment>
            );
          })}
      </>
    );
  };

  return (
    <Row className="p-2 p-md-3 rounded-3 bg-theme-grey-2 border gy-2 m-1 my-lg-o mx-lg-0">
      {!dataPreview && inputFields?.length
        ? renderDynamicForms(inputFields, true)
        : null}
      {dataPreview && renderRecursiveDataPreview()}

      <FormButton
        formButtons={recursiveActions}
        handleNext={handleNext}
        handleCancel={handleCancel}
        handleBack={handleBack}
        handleEdit={handleEdit}
        handleAddMore={handleAddMore}
        isRecursive={true}
        className="recursive_button"
        minLength={minLength}
        maxLength={maxLength}
        isMobile={isMobile}
      />
    </Row>
  );
};

export default PaymentRecursive;
